import React from 'react';
import clsx from 'clsx';

import styles from './ProjectCard.module.css';

export const DraftCard = ({ project }: { project: any }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
        <div className={styles.imageBox}>
          <img
            className={clsx(styles.cardImage, 'blur-sm')}
            src={project.heroImage}
            alt={project.name}
          />
          <div className={styles.overlay}>
            <p className={styles.overlayText}>в процессе</p>
          </div>
        </div>

        <div className={styles.info}>
          <h2 className={styles.title}>{project.name}</h2>
          <p className={styles.subtitle}>
            {`${project.year} ${project.location} ${project.area}m`}
            <sup>2</sup>
          </p>
        </div>
      </div>
    </div>
  );
};
